module.exports = "/packs/images/svg/facilities/calendar~8c060b230aaaee0d0bae84df7c277dc5.svg";